import GeneralErrorPlaceholderSvg from '@/../img/placeholders/general-error-placeholder.svg';
import React from 'react';
import { BackgroundWithLogo } from './common/background-with-logo';
import {
  GenericErrorPlaceholder,
  NAV_OPTIONS,
} from './generic-error-placeholder';

const ErrorMessageHeaderText = () => (
  <>
    <span>Oops,</span>
    <br />
    <span>something went wrong.</span>
  </>
);

const ErrorMessageSubtext = () => (
  <>
    <span>Refresh page to try again</span>
  </>
);

export function DefaultExceptionPlaceholder() {
  return (
    <BackgroundWithLogo>
      <GenericErrorPlaceholder
        renderErrorMessageHeaderText={<ErrorMessageHeaderText />}
        renderErrorMessageSubtext={<ErrorMessageSubtext />}
        renderErrorImage={
          <GeneralErrorPlaceholderSvg height={329} width={680} />
        }
        renderNavigationOptions={[NAV_OPTIONS.Refresh]}
      />
    </BackgroundWithLogo>
  );
}
